import { render, staticRenderFns } from "./CapabilityGrid.vue?vue&type=template&id=045cd9fe&scoped=true"
import script from "./CapabilityGrid.vue?vue&type=script&lang=js"
export * from "./CapabilityGrid.vue?vue&type=script&lang=js"
import style0 from "./CapabilityGrid.vue?vue&type=style&index=0&id=045cd9fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045cd9fe",
  null
  
)

export default component.exports